import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { OnboardControllerModule } from './controllers/OnboardController';

export const OnboardView = angular
  .module('acme.view.onboard', [uiRouter, 'ui.bootstrap', OnboardControllerModule])
  .config(function config($stateProvider: StateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const onboard = {
      name: 'onboard',
      url: '/onboard',
      abstract: true,
      views: {
        main: {
          controller: 'OnboardController',
          templateUrl: 'layouts/standard.tpl.html',
        },
      },
    };

    const onboardDefault = {
      name: 'onboard.default',
      url: '',
      views: {
        'subview-main': {
          templateUrl: 'views/onboard/onboard.tpl.html',
        },
      },
      data: {
        pageTitle: 'Complete Your Profile',
        rule: function (permits) {
          // Allow if state is not in exclusions array
          return permits.indexOf('onboard.default') !== -1;
        },
      },
    };

    $stateProvider.state(onboard).state(onboardDefault);
  }).name;
